let routes = [
	{
		// 登录
		path: '/login',
		name: 'login',
		component: () => import('@/views/login/login'),
		meta: {
			title: '登录',
			keepAlive: true
		}
	},
	{
		// 登录
		path: '/changepassword',
		name: 'changepassword',
		component: () => import('@/views/login/changePassword'),
		meta: {
			title: '修改密码',
			keepAlive: true
		}
	},
	{
		// 健康档案
		path: '/healthrecords',
		name: 'healthrecords',
		component: () => import('@/views/healthRecord/healthIndex/healthIndex'),
		meta: {
			title: '健康档案',
			keepAlive: true
		}
	},
	{
		path: '/personal',
		name: 'personal',
		component: () => import('@/views/healthRecord/personalReport/personal'),
		meta: {
			title: '个人报告',
			keepAlive: true
		}
	},
	{
		path: '/personalSumUp',
		name: 'personalSumUp',
		component: () => import('@/views/healthRecord/personalSumUp/personal'),
		meta: {
			title: '阶段总结',
			keepAlive: true
		}
	},
	{
		path: '/personaldatailInfo',
		name: 'personaldatailInfo',
		component: () => import('@/views/healthRecord/personalSumUp/personalPdf'),
		meta: {
			title: '阶段总结',
			keepAlive: true
		}
	},
	{
		path: '/personaldatail',
		name: 'personaldatail',
		component: () => import('@/views/healthRecord/personalReport/personalPdf'),
		meta: {
			title: '个人报告',
			keepAlive: true
		}
	},
	{
		path: '/physcial',
		name: 'physcial',
		component: () => import('@/views/healthRecord/physcial/physcial'),
		meta: {
			title: '体检报告',
			keepAlive: true
		}
	},
	{
		path: '/physcialdatail',
		name: 'physcialdatail',
		component: () => import('@/views/healthRecord/physcial/physcialdetail'),
		meta: {
			title: '体检报告',
			keepAlive: true
		}
	},
  {
    path: '/physcialBalanceList',
    name: 'physcialBalanceList',
    component: () => import('@/views/healthRecord/physcial/physcialBalanceList'),
    meta: {
      title: '体检报告',
      keepAlive: true
    }
  },
  {
    path: '/physcialBalance',
    name: 'physcialBalance',
    component: () => import('@/views/healthRecord/physcial/physcialBalance'),
    meta: {
      title: '对比详情',
      keepAlive: true
    }
  },
	{
		path: '/unusual',
		name: 'unusual',
		component: () => import('@/views/healthRecord/physcial/unusual'),
		meta: {
			title: '异常解读',
			keepAlive: true
		}
	},
  {
    path: '/consultDetail',
    name: 'consultDetail',
    component: () => import('@/views/healthRecord/consult/consultDetail'),
    meta: {
      title: '会诊详情',
      keepAlive: true
    }
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routerPage/login.js